;(function () {
    function FilterTracking(form) {
        /**
         * local object availability
         * @type {FilterTracking}
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.bindEventsToTrack()
        }

        /**
         * Bind events that should be tracked
         *
         * @method bindEventsToTrack
         * @returns {undefined}
         */
        this.bindEventsToTrack = function () {
            // the submition of the form is fired if a checkbox changes or a search string is submitted
            $(form).submit(function () {
                _this.pushFilterTrackingEvent(false)
            })

            // bind the click on a product. Note that we pass true to the pushFilterTrackingEvent which indicates that
            // the filtering was successful for the user to find the desired product
            $('.js-product-catalog-card-link').click(function () {
                _this.pushFilterTrackingEvent(true)
            })
        }

        /**
         * Push the data of the active filters (value) and active filter categories (type) to the data layer
         *
         * @method pushFilterTrackingEvent
         * @returns {undefined}
         */
        this.pushFilterTrackingEvent = function (success = false) {
            var { concatenatedTypes: types, concatenatedValues: values } = _this.buildTrackingData()
            var event = 'Filter' + (success ? '.Success' : '')
            dataLayer.push({
                type: types,
                value: values,
                event: event,
            })
        }

        /**
         * Get the search string
         *
         * @method getSearchString
         * @returns {String} searchString
         */
        this.getSearchString = function () {
            return $(form).find('.js-search-filter').val()
        }

        /**
         * Build the required data to send for the tracking event
         *
         * The goal is to build 2 Strings.
         * - The first string contains all the active filter types and the key
         *   "search" (when actively searched) separated by a ";"
         *
         *   Example: The following Categories are active: color, shape and search
         *            Which results in: "color;shape;search"
         *
         * - The second string contains all the active filter values and the
         *   search string (when actively searched). Values from the same category (type)
         *   are separated by a ",". The values from different categories are separated by a ";"
         *
         *   Example: The following values are active: green, blue, red, circle, square, "searchstring"
         *            Which results in: "green,blue,red;circle,square;searchstring"
         *
         * @method buildTrackingData
         * @returns {Object} concatenated values and types
         */
        this.buildTrackingData = function () {
            // usage of a set to make sure every type is only once present in the types "array"
            var types = new Set([])
            var values = []
            // get all checkboxes that are active
            $(form)
                .find(':checkbox:checked')
                .toArray()
                .forEach(function (checkbox) {
                    // "magic" to pull the category from the checkboxes parent bucket
                    var checkboxBucket = $(checkbox).parents('.js-filter-bucket')
                    var type = checkboxBucket.attr('id').split('-')[1]

                    // assign a empty array to the index of the desired category if its empty
                    if (!values[type]) {
                        values[type] = []
                    }

                    // add the value to the sub-array of the desired category
                    values[type].push($(checkbox).val())

                    types.add(type)
                })

            // concatenate the types and values as described in the doc block
            var { concatenatedTypes, concatenatedValues } = _this.concatenateTrackingData({ types, values })
            // before returning add the search to the value and types
            return _this.concatSearchStringToTrackingData({ concatenatedTypes, concatenatedValues })
        }

        /**
         * Concatenate the tracking data as described in the doc block for the function buildTrackingData
         *
         * @method concatenateTrackingData
         * @param {Object} {types, values} types as a 1d array, values as 2d array for each type
         * @returns {Object} concatenated values and types without the search
         */
        this.concatenateTrackingData = function ({ types, values }) {
            var concatenatedTypes = Array.from(types).join(';')

            // join the 2d object for values to a string as described in doc-bloc for the function buildTrackingData
            var concatenatedValues = []
            for (var type in values) {
                var valuesForType = values[type]
                concatenatedValues[type] = valuesForType.join(',')
            }
            concatenatedValues = Object.values(concatenatedValues).join(';')

            return { concatenatedTypes, concatenatedValues }
        }

        /**
         * Concatenate the search to the types and values
         *
         * The type for search is "search"
         * The value for the search is the actively searched string
         *
         * @method concatSearchStringToTrackingData
         * @param {String, String} {concatenatedTypes, concatenatedValues} types as a 1d array, values as 2d array for each type
         * @returns {Object} concatenated values and types without the search
         */
        this.concatSearchStringToTrackingData = function ({ concatenatedTypes, concatenatedValues }) {
            var searchString = _this.getSearchString()
            if (searchString) {
                var glue = concatenatedTypes ? ';' : ''
                concatenatedTypes += glue + 'search'
                concatenatedValues += glue + searchString
            }
            return { concatenatedTypes, concatenatedValues }
        }

        /**
         * initialize call FilterTracking
         */
        _this.init()
    }

    window.FilterTracking = window.FilterTracking || {}

    window.FilterTracking.FilterTracking = FilterTracking
})()

$(document).ready(function () {
    // even though we have decided as a team to use .js-xxx classes to select elements form the dom through js
    // here a rel attribute is used to be consistent with de legacy code (the same selector is used in 11 times
    // in 5 different files).
    const form = $('[rel="search-filters"]').find('form')

    if (form) {
        new window.FilterTracking.FilterTracking(form)
    }
})
